import { snakeCase } from 'change-case';

import type { DocumentRelationshipObject } from '~/core/shared/types';

export const getDocumentIncludesForRelationshipObject = (
  relationshipsObject: Record<string, DocumentRelationshipObject>,
  keyPrefixes: string[] = [],
): string[] =>
  Object.entries(relationshipsObject).reduce<string[]>(
    (array, [key, { relationships }]) => {
      const compositeKey = [...keyPrefixes, snakeCase(key)];
      return [
        ...array,
        compositeKey.join('.'),
        ...(relationships
          ? getDocumentIncludesForRelationshipObject(
              relationships,
              compositeKey,
            )
          : []),
      ];
    },
    [],
  );
